module.exports = __webpack_public_path__ + "static/08_global_temp_record_british_nasa-a7ec4c97ba1e07463a01cf5eb506f538.gif";